// ---------------------------------------------------------------------------
// AITalk — ค่าคงที่/ENV (REACT_APP_* ถูกฝังลง bundle ห้ามใส่ secret)
// ---------------------------------------------------------------------------
export const API_BASE_URL = process.env.REACT_APP_API_URL || "https://api.swiftgoldpay.com/api/";

export const GS_URL = process.env.REACT_APP_GS_URL || "";
export const GS_KEY = process.env.REACT_APP_GS_KEY || "";

// Firebase Realtime Database (REST) — หน้าเว็บอ่าน/เขียนตรง ไม่มี server (ดู README + database.rules.json)
export const FB_URL = (process.env.REACT_APP_FIREBASE_URL || "").trim().replace(/\/+$/, "");
/** โหนดราก (ไม่บังคับ) — ใช้แยกข้อมูลทดสอบ เช่น "_test/run1" ; ปกติเว้นว่าง */
export const FB_ROOT = (process.env.REACT_APP_FIREBASE_ROOT || "").trim().replace(/^\/+|\/+$/g, "");

const FORCE_MOCK = process.env.REACT_APP_USE_MOCK === "true";
/** ลำดับใช้งาน: Firebase > Google Sheets (GS) > mock */
export const BACKEND = FORCE_MOCK ? "mock" : FB_URL ? "firebase" : GS_URL ? "gs" : "mock";
export const IS_FB = BACKEND === "firebase";
/** โหมด mock: ไม่ตั้ง FIREBASE_URL/GS_URL หรือสั่ง REACT_APP_USE_MOCK=true -> ทุกอย่างอยู่ใน localStorage ไม่ยิงเน็ต */
export const IS_MOCK = BACKEND === "mock";

export const MOCK_LATENCY = 220;
export const MOCK_PREFIX = "aitalk";

// token ใช้ key เดียวกับระบบอื่นในเครือ (btoa("Bearer " + token))
export const TOKEN_KEY = "scp-acc-tk";
export const PROFILE_KEY = "scp-profile";
export const AUTH_EVENT = "aitalk-auth-change";

export const USER_TYPE = { user: "customer", superUser: "super_user" };

export const PROCESS_TYPE = "aitalk";
export const ORDER_TYPE = { coinTopup: "aitalk_coin_topup" };

export const PARTNER = {
  clientId: process.env.REACT_APP_CLIENT_ID || "",
  clientSecret: process.env.REACT_APP_CLIENT_SECRET || "",
  clientRefId: process.env.REACT_APP_CLIENT_REF_ID || "",
  apigwApiId: process.env.REACT_APP_X_APIGW_API_ID || "",
  customerIdDefault: process.env.REACT_APP_CUSTOMER_ID_DEFAULT || "",
  currency: "THB",
};

export const CAPTCHA = {
  siteKey: process.env.REACT_APP_CLOUDFLARE_SITE_KEY || "",
  masterToken: process.env.REACT_APP_CAPTCHA_TOKEN_MASTER || "",
};

export const QR_EXPIRE_SECONDS = 600;
export const QR_POLL_MS = 5000;
export const QR_INQUIRY_MS = 20000;

export const ENDPOINTS = {
  login: "v1/public/market/login",
  logout: "v1/public/market/logout",
  register: "v1/public/market/customer",
  resetPassword: "v1/public/reset-password",
  profile: "v1/market/profile",
  depositPartner: "transactions/deposits/partner",
  depositGetById: "transactions/deposits/public/get-by-id",
  inquiry: "transactions/inquiry",
};

export const TERMS_VERSION = "2026-10";
